import { render, staticRenderFns } from "./discountTemplate.vue?vue&type=template&id=7294719c&scoped=true&"
import script from "./discountTemplate.vue?vue&type=script&lang=js&"
export * from "./discountTemplate.vue?vue&type=script&lang=js&"
import style0 from "./discountTemplate.vue?vue&type=style&index=0&id=7294719c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7294719c",
  null
  
)

export default component.exports